import Logo from '../../assets/logo.png'
// import svgTwo from '../../assets/media/telegram.8fade749215873ed7ca6cf4b2143080b.svg';
// import svgThree from '../../assets/media/github.b610a9fe6ae8900d57529fc5e63efb77.svg'
export default function Footer() {
    return (
        <>
        {/* footer section start */}
        <footer className="footer bg_img" data-background="assets/images/bg/bg-7.jpg">
          <div className="footer__top">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-12 text-center">
                  <a href="#0" className="footer-logo">
                    <img src={Logo} alt="image" />
           
                  </a>
                  <ul className="footer-short-menu d-flex flex-wrap justify-content-center mt-4">
                    <li>
                      <a href="#0">Home</a>
                    </li>
                    <li>
                      <a href="#0">Privacy &amp; Policy</a>
                    </li>
                    <li>
                      <a href="#0">Terms &amp; Conditions</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="footer__bottom">
            <div className="container">
              <div className="row">
                <div className="col-md-6 text-md-left text-center">
                  <p>
                    © 2023{" "}
                    <a style={{color:'orange'}}>
                    GLOBUS.COM
                    </a>
                    . All rights reserved
                  </p>
                </div>
                <div className="col-md-6">
                  <ul className="social-link-list d-flex flex-wrap justify-content-md-end justify-content-center">
                    <li>
                      <a
                        href="#0"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="facebook"
                      >
                        <i className="lab la-facebook-f" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="#0"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="twitter"
                      >
                        <i className="lab la-twitter" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="#0"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="pinterest"
                      >
                        <i className="lab la-pinterest-p" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="#0"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="pinterest"
                      >
                        <i className="lab la-pinterest-in" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </footer>
        {/* footer section end */}
      </>
      
    );
}